var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArticle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M2.50016 0.833252H1.8335C1.28121 0.833252 0.833496 1.28097 0.833496 1.83325V14.8333C0.833496 15.3855 1.28121 15.8333 1.8335 15.8333H14.8335C15.3858 15.8333 15.8335 15.3855 15.8335 14.8333V1.83325C15.8335 1.28097 15.3858 0.833252 14.8335 0.833252H2.50016ZM14.1668 2.49992V14.1666H2.50016V2.49992H14.1668ZM17.5002 17.4999H5.00016C4.53992 17.4999 4.16683 17.873 4.16683 18.3333C4.16683 18.7935 4.53993 19.1666 5.00016 19.1666H18.1668C18.7191 19.1666 19.1668 18.7189 19.1668 18.1666V4.99992C19.1668 4.53968 18.7937 4.16658 18.3335 4.16658C17.8733 4.16658 17.5002 4.53968 17.5002 4.99992V17.4999ZM12.5002 4.16658H4.16683V5.83325H12.5002V4.16658ZM4.16683 7.49992H12.5002V9.16658H4.16683V7.49992ZM10.0002 10.8333H4.16683V12.4999H10.0002V10.8333Z",
  fill: "#1051A1"
}))));
export default SvgArticle;